"use client";

import { Tokens } from "~/services/api/types/tokens";
import { User } from "~/services/api/types/user";
import {
    createContext,
    type Dispatch,
    type RefObject,
    type SetStateAction,
} from "react";

export type TokensInfo = Tokens | null;

/** Called with the bearer the API rejected with a 401. */
export type OnUnauthorized = (rejectedToken: string) => void;

export const AuthContext = createContext<{
    user: User | null;
    isLoaded: boolean;
    isLoading: boolean;
    /** The API rejected the session with a 401; cleared by the next sign-in. */
    isSessionExpired: boolean;
}>({
    user: null,
    isLoaded: true,
    isLoading: true,
    isSessionExpired: false,
});

export const AuthActionsContext = createContext<{
    setUser: Dispatch<SetStateAction<User | null>>;
    logOut: () => Promise<void>;
        }>({
            setUser: () => {},
            logOut: async () => {},
        });

export const AuthTokensContext = createContext<{
    tokensInfoRef: RefObject<Tokens>;
    setTokensInfo: (tokensInfo: TokensInfo) => void;
    onUnauthorized: OnUnauthorized;
        }>({
            tokensInfoRef: {
                current: {
                    token: null,
                    refreshToken: null,
                    tokenExpires: null,
                },
            },
            setTokensInfo: () => {},
            onUnauthorized: () => {},
        });
